import ReactQuill from "react-quill";

const QuillEditor = ({
  value,
  onChange,
  style,
}: {
  value: string;
  onChange: (e: string) => void;
  style?: any;
}) => {
  // Full toolbar options
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      ["link", "image", "video"],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      ["clean"], // removes formatting
    ],
  };

  const formats = [
    "header",
    "font",
    "list",
    "bullet",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "script",
    "blockquote",
    "code-block",
    "link",
    "image",
    "video",
    "indent",
    "direction",
  ];

  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      theme="snow"
      modules={modules}
      formats={formats}
      placeholder="Start writing..."
      style={style}
    />
  );
};

export default QuillEditor;
